<script lang="ts">
	import Popover from '$lib/components/Popover/Popover.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import { _ } from 'svelte-i18n';
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	import { page } from '$app/stores';
	import ButtonLink from '$lib/components/ButtonLink/ButtonLink.svelte';
	import { isLocalDevelopment } from '$lib/utils/environmentResolver';

	const { user, restApi, pod } = getHubStores();
	const hubPrefix = $page.params.hubPrefix;

	const signOut = async () => {
		await restApi.signOut();
		window.location.assign(`/${hubPrefix}`);
		if (isLocalDevelopment(pod)) {
			document.cookie = 'jwt= ';
		}
	};
</script>

<Popover position="bottom-inline-start">
	<Avatar name={$user.name} url={$user.avatar_url} slot="target" />
	<div slot="content" class={'accountMenuSettings'}>
		<Avatar name={$user.name} url={$user.avatar_url} />
		<div class="accountMenuData">
			<span>{$user.name}</span>
			<div style="display:flex; align-items:center; line-height:10px">
				<a href={`/${hubPrefix}/settings/user/profile`}>{$_('common.account.settings')}</a>
				{#if !$page.data.isMobileApp}
					<div class="dot">•</div>
					<ButtonLink on:click={signOut}>{$_('common.sign.out')}</ButtonLink>
				{/if}
			</div>
		</div>
	</div>
</Popover>

<style>
	.accountMenuSettings {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: auto;
		inline-size: auto;
		padding: var(--gutterDefault);
		background-color: white;
	}

	.accountMenuData {
		display: flex;
		flex-direction: column;
		inline-size: max-content;
		padding-block: 0;
		padding-inline: var(--gutterDefault);
	}

	.accountMenuData span {
		color: var(--secondaryHeadlineColor);
		font-size: var(--fontSizeNormal);
	}

	.accountMenuData a,
	.accountMenuData :global(button) {
		margin: 0;
		padding: 0;
		color: var(--secondaryHeadlineColor);
		font-size: 13px;
	}

	.dot {
		margin: var(--gutterSmaller);
		color: grey;
	}
</style>
